import { getDeviceId } from "./logger";
import { entriesForDay } from "./store";
import { readSessionToken } from "./sync";

/**
 * Date-wise downloads, as newline-delimited JSON (one entry per line — opens in any
 * editor, and `grep` works on it).
 *
 * From the device: whatever this phone still holds for that day, uploaded or not.
 * From the server: the day as the server stored it, which reaches back past what the
 * phone has already cleared. A captain gets only their own; an admin can filter.
 */
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function downloadDayFromDevice(businessDate) {
  const rows = await entriesForDay(businessDate);
  const text = rows
    .map(row =>
      JSON.stringify({
        seq: row.seq,
        business_date: row.business_date,
        occurred_at: row.occurred_at,
        kind: row.kind,
        route: row.route,
        request_id: row.request_id,
        uploaded: row.synced === 1,
        refused_reason: row.refused_reason,
        detail: row.detail,
      })
    )
    .join("\n");
  saveBlob(
    new Blob([text ? `${text}\n` : ""], { type: "application/x-ndjson" }),
    `vibez-logs-${businessDate}-device-${getDeviceId().slice(0, 8)}.ndjson`
  );
  return rows.length;
}

export async function downloadDayFromServer({ businessDate, deviceId = null, source = null }) {
  const token = readSessionToken();
  if (!token) throw new Error("Sign in to download logs from the server.");
  const params = new URLSearchParams({ business_date: businessDate });
  if (deviceId) params.set("device_id", deviceId);
  if (source) params.set("source", source);
  let response;
  try {
    response = await fetch(`${API}/logs/export?${params}`, { headers: { Authorization: `Bearer ${token}` } });
  } catch (error) {
    throw new Error(`Server unreachable: ${error?.message || error}`);
  }
  if (!response.ok) throw new Error(`Server refused the download (${response.status}).`);
  const blob = await response.blob();
  const disposition = response.headers.get("content-disposition") || "";
  const named = disposition.match(/filename="([^"]+)"/);
  saveBlob(blob, named ? named[1] : `vibez-logs-${businessDate}.ndjson`);
  return blob.size;
}
